// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2GaSL","actionsCol":"EnrolledClinics_actionsCol__1ou1O"};